import ApiService from './ApiService'

const resourceUrl = `${ApiService.prefix}callback.jsp`

export default {
  unpinShortcut(favouriteId) {
    const bodyFormData = new FormData()
    bodyFormData.append('command', 'UnpinShortcut')
    bodyFormData.append('favouriteId', favouriteId)

    return this.genericPost(bodyFormData)
  },
  genericPost(data) {
    return ApiService.post(resourceUrl, data, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
  },
}
